<template>
  <div :class="$style['exchange-record-header']">
    <wt-box direction="row">
      <div>累计总积分：<span :class="$style['exchange-record-number']" v-if="consumedPoints || consumedPoints === 0">{{consumedPoints}}</span><i class="el-icon-loading" v-else></i></div>
      <div>当前可用积分：<span :class="$style['exchange-record-number']" v-if="consumedPointsValid || consumedPointsValid === 0">{{consumedPointsValid}}</span><i class="el-icon-loading" v-else></i></div>
    </wt-box>
    <pt-page-factor-filter :labels="filterLabels" v-model="params" ref="filter" @Filter="Filter">
      <template>
        <el-button type="primary" @click="Filter()">筛选</el-button>
        <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
      </template>
    </pt-page-factor-filter>
    <pt-sub-title title="积分明细"></pt-sub-title>
    <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber" :page-size="pageSize" ref="table">
      <wt-table :list="tableData" :labels="tableLabels">
      </wt-table>
    </wt-paged-table>
  </div>
</template>
<script>
import {
  emptyObject
} from '@/utils/lifebankUtils'
export default {
  props: {
    pageSize: {
      type: Number,
      default: 10
    },
    userLogin: {
      type: String,
      default: ''
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    filterLabels: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0,
      consumedPoints: null,
      consumedPointsValid: null,
      pointsType: [],
      params: {},
      paramDate: {}
    }
  },
  watch: {
    pointsType: {
      handler (val) {
        if (val) {
          this.filterLabels.forEach(item => {
            if (item.value === 'pointsTaskId') {
              item.options = val.map(e => {
                return {
                  label: e.content,
                  value: e.id
                }
              })
            }
          })
        }
      },
      deep: true
    },
    paramDate: {
      handler (val) {
        this.getTableData(0)
      },
      deep: true
    }
  },
  methods: {
    cleanParams () {
      emptyObject(this.params)
    },
    Filter () {
      this.paramDate = this.params
    },
    getTableData (page, next) {
      let data = {
        userLogin: this.userLogin,
        pageable: {
          page: page,
          size: this.pageSize
        },
        ...this.paramDate
      }
      this.$store.dispatch('getUserIntegralList', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$message.error(err || '获取用户积分记录失败')
      })
    },
    getUserIntegral () {
      this.$store.dispatch('getUserIntegral', this.userLogin).then(res => {
        this.consumedPoints = res.consumedPoints
        this.consumedPointsValid = res.consumedPointsValid
      }).catch(err => {
        this.$message.error(err || '获取积分信息失败')
      })
    },
    getUserIntegralType () {
      let data = {
        pointsType: 'CONSUMED_POINTS'
      }
      this.$store.dispatch('getUserIntegralType', data).then(res => {
        this.pointsType = res
      }).catch(err => {
        this.$message.error(err || '获取积分信息失败')
      })
    }
  },
  created () {
    this.getUserIntegral()
    this.getUserIntegralType()
  }
}
</script>
<style module lang="less">
  .exchange-record-header {
    :global {
      .wt-box {
        display: inline-flex;
        color: #EFC68C;
        margin: .5rem .3rem;
      }
    }
  }

  .exchange-record-number {
    font-size: 35px;
    margin: 0 1rem 0 .1rem;
  }
</style>
